<template>
  <div class="sample-video">
    <div :id="localId"></div>
  </div>
</template>

<script>
import uuid from 'uuid/v4'

export default {
  name: 'SampleVideo',
  props: {
    videoId: {
      type: String,
      required: true,
    },
    autostart: {
      type: Boolean,
      required: false,
      default: () => {
        return true
      },
    },
  },
  data() {
    return {
      localId: `u${uuid()}`,
      player: null,
    }
  },
  methods: {
    setupPlayer() {
      this.player = jwplayer(this.localId)
      this.player.setup({
        key: process.env.VUE_APP_JWPLAYER_KEY,
        aspectratio: '16:9',
        autoPause: {},
        autostart: this.autostart ? 'viewable' : false,
        cast: {
          appid: '00000000',
        },
        controls: true,
        displaydescription: false,
        displaytitle: false,
        ga: {
          idstring: 'title',
        },
        height: 360,
        mute: true,
        ph: 3,
        pid: 'T92WUUWc',
        playbackRateControls: false,
        playlist: `//content.jwplatform.com/v2/media/${this.videoId}`,
        preload: 'metadata',
        repeat: false,
        skin: {
          controlbar: {
            icons: '#EF7D22',
          },
          timeslider: {
            progress: '#FFF4E4',
          },
        },
        stretching: 'uniform',
        width: '100%',
      })
    },
  },
  async created() {
    await this.$nextTick()
    this.setupPlayer()
  },
  destroyed() {
    if (this.player) this.player.remove()
  },
}
</script>

<style lang="scss">
.sample-video {
  position: relative;
  width: 100%;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
